<script>
import { mapActions } from "vuex";
import Confirm from "@/components/ConfirmModal.vue";
import Likes from "@/components/likes.vue";
import { toDate, toTime } from "@/utils/time.js";
export default {
  name: "Muros",
  components: { Confirm, Likes },
  props: {
    color: {
      type: String,
    },
    muros: {},
  },
  data() {
    return {
      id_usuario: this.$ls.get("user").id_usuario,
      texto_comentario: "",
      texto_publicacion_edit: "",
      previewEdit: "",
      imagen_muro_edit: "",
      imagen_formato_edit: "",
      texto_comentario_edit: "",
      user_likes: false,
      imagen_perfil_user: this.$ls.get("user").imagen_perfil,
      confirmFn: () => {},
      confirm: false,
      imageHeights: {},
      likesSelected: [],
      editingMuro: false,
      confirmText: {
        muro: "¿Esta segur@ que desea eliminar <br/> esta publicación?",
        comentario: "¿Esta segur@ que desea eliminar <br/> este comentario?",
      },
      confirmTextType: "muro",
    };
  },
  methods: {
    ...mapActions("home", [
      "updatePostMuro",
      "addLikeComentario",
      "delLikeComentario",
      "addLikeMuroPost",
      "delLikeMuroPost",
      "crearComentariosPostMuro",
      "updateComentariosPostMuro",
      "updatePostMuro",
      "delComentarioPostMuro",
      "delPostMuro",
    ]),
    toDate(date) {
      return toDate(date);
    },
    toTime(date) {
      return toTime(date);
    },
    confirmarEliminarMuro(id_muro) {
      this.confirmTextType = "muro";
      this.confirm = true;
      this.confirmFn = () => {
        this.eliminarMuro(id_muro);
        this.confirm = false;
      };
    },
    async eliminarMuro(id_muro) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_muro: id_muro,
      };
      const resDel = await this.delPostMuro(data_);
      if (!resDel) {
        console.log("Falla eliminarMuro", resDel);
      }
    },
    async toggleLikeMuro(muro) {
      // const liked = !!muro.confirm_like;
      const data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_objeto: muro.id_muro,
      };
      let res = null;

      if (this.iLike(muro.likes_global)) {
        res = await this.addLikeMuroPost(data_);
      } else {
        res = await this.delLikeMuroPost(data_);
      }
      if (!res) {
        this.toastGenericError();
      }
    },

    async comentarMuro(id_muro) {
      if (this.texto_comentario === "") {
        this.$toast.open({
          message: "Por favor, escribe un comentario acorde a la publicación, no puedes enviar un comentario vacío.",
          type: "warning",
          duration: 5000,
          position: "top-right",
        });
        return;
      }
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_muro: id_muro,
        texto: this.texto_comentario,
      };
      await this.crearComentariosPostMuro(data_).then((res) => {
        if (res) {
          this.texto_comentario = "";
        } else {
          console.log("Falla crearComentariosPostMuro", res);
        }
      });
    },
    async toggleLikeComentarioMuro(id, id_muro, liked) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_comentario: id,
        id_muro: id_muro,
      };
      if (this.filterLikes(liked) !== null) {
        await this.delLikeComentario(data_).then((res) => {
          if (res) {
            this.user_likes = false;
          } else {
            console.log("Falla dar like", res);
          }
        });
      } else {
        await this.addLikeComentario(data_).then((res) => {
          if (res) {
            this.user_likes = true;
          } else {
            console.log("Falla dar like", res);
          }
        });
      }
    },
    togglePublicacionEdit(muro) {
      muro.isEditing = !muro.isEditing;
      this.texto_publicacion_edit = muro.texto;
      this.imagen_muro_edit = "";
      this.imagen_formato_edit = "";
      this.previewEdit = muro.imagen_muro;
      this.$forceUpdate();
    },
    toggleComentarioEdit(id_comentario) {
      this.muros.forEach((muro) => {
        const comentario = muro.comentarios.find(
          (comentario) => comentario.id_comentario == id_comentario
        );
        if (comentario) {
          comentario.isEditing = !comentario.isEditing;
          this.texto_comentario_edit = comentario.texto;
        }
      });
      this.$forceUpdate();
    },
    handleFileEdit(id_muro) {
      const promise = this.getBase64(
        this.$refs[`fileEdit${id_muro}`][0].files[0]
      );
      const x = this;
      promise.then(function (result) {
        x.imagen_muro_edit = result.split(",")[1];
        x.previewEdit = result;
        if (x.imagen_muro_edit && x.imagen_muro_edit != "") {
          x.imagen_formato_edit =
            x.$refs[`fileEdit${id_muro}`][0].files[0]["type"];
        }
        x.$forceUpdate();
      });
    },
    borrarImgEdit() {
      this.imagen_muro_edit = "";
      this.imagen_formato_edit = "";
      this.previewEdit = "";
      this.$forceUpdate();
    },
    async editarMuro(id_muro) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        imagen_muro: this.imagen_muro_edit,
        imagen_formato: this.imagen_formato_edit,
        texto: this.texto_publicacion_edit,
        id_muro: id_muro,
      };
      this.editingMuro = true;
      await this.updatePostMuro(data_).then((res) => {
        if (res) {
          this.imagen_muro_edit = "";
          this.imagen_formato_edit = "";
          this.texto_publicacion_edit = "";
          this.previewEdit = "";
          this.muros
            .forEach((muro) => {
              if (muro.id_muro == id_muro) {
                muro.isEditing = false;
              }
            })
            .finaly(() => {
              this.editingMuro = false;
            });
        } else {
          console.log("Falla editarMuro", res);
          this.editingMuro = false;
        }
      });
    },
    async editarComentarioMuro(id_comentario, id_muro) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_muro: id_muro,
        id_comentario: id_comentario,
        texto: this.texto_comentario_edit,
      };
      await this.updateComentariosPostMuro(data_).then((res) => {
        if (res) {
          this.texto_comentario_edit = "";
        } else {
          console.log("Falla editarComentarioMuro", res);
        }
      });
    },
    confirmarEliminarComentarioMuro(id_comentario, id_muro) {
      this.confirmTextType = "comentario";
      this.confirm = true;
      this.confirmFn = () => {
        this.eliminarComentarioMuro(id_comentario, id_muro);
        this.confirm = false;
      };
    },
    async eliminarComentarioMuro(id_comentario, id_muro) {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_muro: id_muro,
        id_comentario: id_comentario,
      };
      const resDel = await this.delComentarioPostMuro(data_);
      if (!resDel) {
        console.log("Falla eliminarComentarioMuro", resDel);
      }
    },

    //FF
    textareaComentario() {
      let textarea = document.querySelector("#textarea-comentario");
      if (this.texto_comentario === "") {
        textarea.style.height = "63px";
        return;
      }
      textarea.style.height = "1px";
      textarea.style.height = 25 + textarea.scrollHeight + "px";
    },

    iLike(list) {
      const likes = list.filter(
        ({ usuario }) => usuario.id_usuario == this.$ls.get("user").id_usuario
      );
      return likes.length == 0;
    },
    toggleImageHeight(id_muro) {
      // Toggle between 'auto' and '300px'
      if (this.imageHeights[id_muro] === "auto") {
        this.$set(this.imageHeights, id_muro, "300px");
      } else {
        this.$set(this.imageHeights, id_muro, "auto");
      }
    },
    filterLikes(likes) {
      const yourLike = likes.filter(
        ({ usuario }) =>
          usuario[0].id_usuario == this.$ls.get("user").id_usuario
      );
      return yourLike.length == 0 ? null : yourLike[0];
    },
    textLike(muro) {
      const { likes, likes_global, confirm_like_global } = muro;

      let lG = likes_global;
      let cLG = confirm_like_global;

      if (lG === undefined) {
        lG = likes;
        cLG = this.filterLikes(likes);
      }

      if (lG.length == 0) return "";
      if (lG.length == 1 && cLG != null) return "Te gusta";
      return "Le gusta a";
    },

    likesSelectedFn(likes, format = false) {
      let likes_ = likes;
      if (format) {
        likes_ = likes.map((like) => ({
          ...like,
          usuario: like.usuario[0],
        }));
      }

      this.likesSelected = likes_;
    },
  },
};
</script>

<template>
  <div v-if="muros" class="row">
    <div class="col">
      <transition-group name="list" tag="div">
        <div
          v-for="muro in muros"
          :key="'muro-' + muro.id_muro"
          class="card card-custom border-0 mb-3"
        >
          <!-- {{ muro }} -->
          <div class="card-body">
            <div class="d-flex">
              <div class="flex-shrink-0 avatar-user">
                <img
                  width="50"
                  height="50"
                  v-if="
                    muro.usuario &&
                    (muro.usuario[0].imagen_perfil ||
                      /.jpg\.jpeg\.png/.test(muro.usuario[0].imagen_perfil))
                  "
                  :src="muro.usuario ? muro.usuario[0].imagen_perfil : '#'"
                  class="img-object-cover rounded-circle me-3"
                  alt="Imagen de usuario"
                />
                <img
                  v-else
                  width="50"
                  height="50"
                  src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                  class="img-object-cover rounded-circle me-3"
                  alt="Imagen de usuario"
                />
              </div>
              <div class="flex-grow-1">
                <div class="d-flex mb-3">
                  <div class="flex-grow-1">
                    <h5 class="font-700 h5-custom text-secondary mb-0">
                      {{
                        muro.usuario
                          ? capitalizeFirstLetter(muro.usuario[0].primer_nombre)
                          : ""
                      }}
                      {{
                        muro.usuario
                          ? capitalizeFirstLetter(
                              muro.usuario[0].apellido_paterno
                            )
                          : ""
                      }}
                    </h5>
                    <span class="text-secondary text-opacity-50">
                      {{ toDate(muro.fecha_creacion) }}
                      &nbsp;
                      {{ toTime(muro.fecha_creacion) }}
                    </span>
                  </div>
                  <div class="flex-shrink-0">
                    <button
                      v-if="
                        muro.usuario && muro.usuario[0].id_usuario == id_usuario
                      "
                      @click="togglePublicacionEdit(muro)"
                      class="btn btn-sm btn-custom-line btn-custom-line-gray border-0"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-pen"
                        class="color-main"
                      ></font-awesome-icon>
                    </button>
                    <button
                      v-if="
                        muro.usuario && muro.usuario[0].id_usuario == id_usuario
                      "
                      @click="confirmarEliminarMuro(muro.id_muro)"
                      class="btn btn-sm btn-custom-line btn-custom-line-gray ms-2 border-0"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-trash"
                        class="color-main"
                      ></font-awesome-icon>
                    </button>
                  </div>
                </div>

                <template v-if="!muro.isEditing">
                  <div class="row">
                    <div class="col transition-height">
                      <p class="text-secondary text-opacity-75">
                        {{ muro.texto }}
                      </p>
                      <img
                        v-if="muro.imagen_muro"
                        :src="muro.imagen_muro"
                        class="img-h-300 rounded-4 border"
                        alt="Imagen de publicación"
                        :style="{
                          height: imageHeights[muro.id_muro] || '300px',
                        }"
                        @click="toggleImageHeight(muro.id_muro)"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </template>

                <template v-if="muro.isEditing">
                  <div class="row">
                    <div class="col">
                      <textarea
                        id="textarea-muro-edit"
                        class="textarea-auto textarea-250"
                        placeholder="Escribe un comentario ..."
                        v-model="texto_publicacion_edit"
                        maxlength="500"
                      ></textarea>
                      <div class="form-text text-end text-secondary">
                        {{ texto_publicacion_edit.length }} / 500
                      </div>

                      <div v-if="previewEdit" class="d-flex position-relative">
                        <a
                          href="javascript:"
                          class="btn-remove btn-remove-main position-absolute btn-remove-top-left"
                          @click="borrarImgEdit"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-xmark"
                          ></font-awesome-icon>
                        </a>
                        <img
                          :src="previewEdit"
                          class="img-h-300 rounded-4"
                          alt="Vista previa de imagen"
                        />
                      </div>

                      <div class="h4 pb-2 mb-2 border-bottom"></div>

                      <div
                        class="d-flex justify-content-end align-items-center"
                      >
                        <div class="flex-grow-1">
                          <label
                            :for="`file-input-edit-${muro.id_muro}`"
                            class="link-secondary pointer-event"
                          >
                            <span v-if="previewEdit === ''" key="adjuntar-img">
                              <font-awesome-icon
                                icon="fa-solid fa-image"
                                class="color-main pe-1"
                              ></font-awesome-icon>
                              Adjuntar imagen
                            </span>
                            <span v-if="previewEdit !== ''" key="editar-img">
                              <font-awesome-icon
                                icon="fa-solid fa-square-pen"
                                class="color-main pe-1"
                              ></font-awesome-icon>
                              Editar imagen
                            </span>
                          </label>

                          <input
                            :id="`file-input-edit-${muro.id_muro}`"
                            class="d-none"
                            type="file"
                            accept="image/*"
                            :ref="`fileEdit${muro.id_muro}`"
                            @change="handleFileEdit(muro.id_muro)"
                          />
                        </div>
                        <div class="flex-shrink-0 d-flex">
                          <button
                            class="btn btn-custom btn-custom-line-main me-2"
                            :disabled="texto_publicacion_edit == '' &&  imagen_muro_edit == ''"
                            @click="editarMuro(muro.id_muro)"
                          >
                            <div v-show="editingMuro" class="me-2 pb-1">
                              <div class="loader"></div>
                            </div>
                            Guardar
                          </button>
                          <button
                            class="btn btn-custom btn-custom-line-gray"
                            @click="togglePublicacionEdit(muro)"
                          >
                            Cancelar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>

            <div
              class="card-custom-footer d-flex pt-3 justify-content-end align-items-center"
            >
              <div>
                <!-- {{ muro }} -->
                <a
                  href="javascript:"
                  @click="
                    textLike(muro) !== 'Te gusta' &&
                      likesSelectedFn(muro.likes_global)
                  "
                  class="me-2"
                >
                  {{ textLike(muro) }}
                </a>
                <a
                  href="javascript:"
                  @click="toggleLikeMuro(muro)"
                  class="card-custom-footer-like color-main"
                >
                  <!-- {{ muro.confirm_like.length }} -->
                  <template v-if="muro.confirm_like_global == null">
                    <font-awesome-icon
                      icon="fa-solid fa-heart"
                    ></font-awesome-icon>
                  </template>
                  <template v-else>
                    <font-awesome-icon
                      icon="fa-solid fa-heart"
                      class="color-red"
                    ></font-awesome-icon>
                  </template>
                </a>
                <span class="card-custom-footer-like-count ms-1">
                  {{ muro.likes_global.length }}
                </span>
              </div>
              <div class="ms-3">
                <a
                  href="javascript:"
                  class="card-custom-footer-like color-main"
                  data-bs-toggle="collapse"
                  :data-bs-target="`#collapse-${muro.id_muro}`"
                >
                  <font-awesome-icon
                    icon="fa-solid fa-comment"
                  ></font-awesome-icon>
                </a>
                <span class="card-custom-footer-like-count ms-1">
                  {{ muro.comentarios.length }}
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div
                  :id="`collapse-${muro.id_muro}`"
                  class="collapse comentar-colapsable col-12 mt-2"
                >
                  <div class="d-flex">
                    <div class="flex-shrink-0 avatar-user">
                      <img
                        width="60"
                        height="60"
                        v-if="
                          !imagen_perfil_user ||
                          !/.jpg|.jpeg|.png/.test(imagen_perfil_user)
                        "
                        src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                        class="img-object-cover rounded-circle me-3"
                      />
                      <img
                        v-else
                        width="60"
                        height="60"
                        :src="imagen_perfil_user"
                        class="img-object-cover rounded-circle me-3"
                      />
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <textarea
                        @keyup="textareaComentario()"
                        id="textarea-comentario"
                        class="textarea-auto"
                        placeholder="Escribe un comentario ..."
                        rows="3"
                        v-model="texto_comentario"
                        maxlength="255"
                      ></textarea>
                      <div
                        class="d-flex align-items-center justify-content-between"
                      >
                        <div class="form-text text-end text-secondary">
                          {{ texto_comentario.length }} / 255
                        </div>
                        <button
                          class="btn btn-custom-line-main btn-sm me-2"
                          :disabled="texto_comentario == ''"
                          @click="comentarMuro(muro.id_muro)"
                        >
                          Comentar
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="h4 pb-4 mb-4 border-bottom"></div>

                  <template v-if="muro.comentarios.length > 0">
                    <div
                      v-for="comentario in muro.comentarios"
                      :key="comentario.id_comentario"
                    >
                      <div class="d-flex border-bottom mb-3">
                        <div class="flex-shrink-0 avatar-user">
                          <img
                            width="50"
                            height="50"
                            v-if="
                              comentario.usuario[0].imagen_perfil ||
                              /.jpg|.jpeg|.png/.test(
                                comentario.usuario[0].imagen_perfil
                              )
                            "
                            :src="comentario.usuario[0].imagen_perfil"
                            class="img-object-cover rounded-circle me-3"
                            alt="Imagen de usuario"
                          />
                          <img
                            v-else
                            width="50"
                            height="50"
                            src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
                            class="img-object-cover rounded-circle me-3"
                            alt="Imagen de usuario"
                          />
                          <!--
                            <span class="avatar-user-online"></span>
                          -->
                        </div>
                        <div class="flex-grow-1">
                          <div class="d-flex mb-3">
                            <div class="flex-grow-1">
                              <h5
                                class="font-700 h5-custom text-secondary mb-0"
                              >
                                {{
                                  capitalizeFirstLetter(
                                    comentario.usuario[0].primer_nombre
                                  )
                                }}
                                {{
                                  capitalizeFirstLetter(
                                    comentario.usuario[0].apellido_paterno
                                  )
                                }}
                              </h5>
                              <span class="text-secondary text-opacity-50">
                                {{
                                  toDate(comentario.fecha_creacion | new Date())
                                }}
                                &nbsp;
                                {{
                                  toTime(comentario.fecha_creacion | new Date())
                                }}
                              </span>
                            </div>
                            <div class="flex-shrink-0 d-flex align-items-start">
                              <button
                                v-if="
                                  comentario.usuario[0].id_usuario ===
                                  id_usuario
                                "
                                @click="
                                  toggleComentarioEdit(comentario.id_comentario)
                                "
                                class="btn btn-sm btn-custom-line btn-custom-line-gray border-0"
                                data-bs-toggle="tooltip"
                                data-bs-placement="right"
                                data-bs-custom-class="tooltip-custom tooltip-custom-main"
                                data-bs-title="Nueva auditoría"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-pen"
                                ></font-awesome-icon>
                              </button>
                              <button
                                v-if="
                                  comentario.usuario[0].id_usuario ===
                                  id_usuario
                                "
                                @click="
                                  confirmarEliminarComentarioMuro(
                                    comentario.id_comentario,
                                    muro.id_muro
                                  )
                                "
                                class="btn btn-sm btn-custom-line btn-custom-line-gray ms-2 border-0"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-trash"
                                ></font-awesome-icon>
                              </button>
                            </div>
                          </div>
                          <p
                            class="p-3 bg-secondary bg-opacity-10 rounded text-secondary text-opacity-75 mb-1"
                          >
                            <template v-if="!comentario.isEditing">
                              {{ comentario.texto }}
                            </template>

                            <template v-if="comentario.isEditing">
                              <textarea
                                class="textarea-auto textarea-120"
                                rows="3"
                                v-model="texto_comentario_edit"
                                maxlength="255"
                              ></textarea>
                              <div class="d-flex justify-content-between">
                                <div>
                                  <button
                                    class="btn btn-sm btn-custom-line-main"
                                    @click="
                                      editarComentarioMuro(
                                        comentario.id_comentario,
                                        muro.id_muro
                                      )
                                    "
                                  >
                                    <font-awesome-icon
                                      icon="fa-solid fa-floppy-disk"
                                    ></font-awesome-icon>
                                    Guardar
                                  </button>
                                  <button
                                    class="btn btn-sm btn-custom-line-dark ms-2"
                                    @click="
                                      toggleComentarioEdit(
                                        comentario.id_comentario
                                      )
                                    "
                                  >
                                    <font-awesome-icon
                                      icon="fa-solid fa-xmark"
                                    ></font-awesome-icon>
                                    Cancelar
                                  </button>
                                </div>
                                <div class="form-text text-end text-secondary">
                                  {{ texto_comentario_edit.length }} / 255
                                </div>
                              </div>
                            </template>
                          </p>
                          <div
                            class="flex-shrink-0 d-flex justify-content-end mb-3"
                          >
                            <!-- {{ comentario }} -->
                            <a
                              href="javascript:"
                              @click="
                                textLike(comentario) !== 'Te gusta' &&
                                  likesSelectedFn(comentario.likes, true)
                              "
                              class="me-2"
                            >
                              {{ textLike(comentario) }}
                            </a>
                            <a
                              href="javascript:"
                              @click="
                                toggleLikeComentarioMuro(
                                  comentario.id_comentario,
                                  muro.id_muro,
                                  comentario.likes
                                )
                              "
                              class="card-custom-footer-like color-main"
                            >
                              <span
                                v-if="filterLikes(comentario.likes)"
                                :key="'solid-heart-' + comentario.id_comentario"
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-heart"
                                  class="color-red"
                                ></font-awesome-icon>
                              </span>
                              <span
                                v-else
                                :key="
                                  'regular-heart-' + comentario.id_comentario
                                "
                              >
                                <font-awesome-icon
                                  icon="fa-solid fa-heart"
                                ></font-awesome-icon>
                              </span>
                              <span class="card-custom-footer-like-count">
                                {{ comentario.likes.length }}
                              </span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
    <Confirm :isVisible="confirm" @accept="confirmFn" @reject="confirm = false">
      <span v-html="confirmText[confirmTextType]"></span>
    </Confirm>
    <Likes
      v-show="likesSelected.length > 0"
      :likes="likesSelected"
      @close="likesSelected = []"
    ></Likes>
  </div>
</template>
